export default __webpack_public_path__ + "static/media/tarkan1.52b091bb.jpg";